const files = import.meta.glob('./**/store.js', { eager: true });
const modules = {};
Object.keys(files).forEach((key) => {
  let moduleName = key.replace(/(\.\/|\.js)/g, ''); // Remove dot in file name
  moduleName = moduleName.replace(/\/store$/g, ''); // Remove /store in file name
  modules[moduleName] = files[key].default;
});

export default modules;
